import {Injectable} from '@angular/core';

/** Provides information about the current URL that works well in Angular Universal also. It also provides
 * immutable info about the current site's root and other URLs.
 */
@Injectable({
    providedIn: 'root'
})
export class PathService {
    private static DEV_ORIGIN = "http://watney/admin";
    private static BASE_DOMAIN = "rapidrona.com";
    private static HOME_DOMAIN = "admin.rapidrona.com";
    private static STAGING_HOST_NAME = "admin.staging.rapidrona.com";
    private static STAGING_ORIGIN = "https://" + PathService.STAGING_HOST_NAME;
    private static LIVE_HOST_NAME = PathService.HOME_DOMAIN;
    private static LIVE_ORIGIN = "https://" + PathService.LIVE_HOST_NAME;

    /** The host name used to access the current page */
    private readonly host: string;
    private readonly origin:string;
    private _siteRoot: string = null;


    /** Initializes service
     *
     */
    constructor() {
        this.host = document.location.host;
        let proto: string = document.location.protocol;

        if (proto?.endsWith(':'))
            proto = proto.substr(0, proto.length-1);
        if (this.host === PathService.LIVE_HOST_NAME)
            this.origin = PathService.LIVE_ORIGIN;
        else if (this.host === PathService.STAGING_HOST_NAME)
            this.origin = PathService.STAGING_ORIGIN;
        else
            this.origin = `${proto}://${this.host}`;
    }

    get originRoot(): string {
        return this.origin;
    }

    /** Returns the absolute URL for the root of the site
     *
     * @returns {string}
     */
    get siteRoot(): string {
        if (!this._siteRoot) {
            // If we're running from elsewhere (such as localhost): use the default origin
            if (!this.origin.endsWith(PathService.BASE_DOMAIN))
                this._siteRoot = PathService.DEV_ORIGIN;
            // Otherwise use same origin as current page (this will include https schema if applicable
            else
                this._siteRoot = this.origin;
        }
        return this._siteRoot;
    }

    /** Returns the absolute URL for the root of our own API URLs
     *
     * @returns {string} the URL
     */
    get apiRoot(): string {
        return this.siteRoot + '/api';
    }

    /** Checks whether the app is currently running on the live site (as opposed to a local test, or staging site)
     *
     * @returns {boolean} true if on live site, false otherwise
     */
    isLiveSite(): boolean {
        return this.host === PathService.LIVE_HOST_NAME;
    }
}
